import { Select } from "antd";
import React, { useEffect, useState } from "react";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setSelectedRpmPatient } from "../../../../../Redux/actions/rpmActions";
import { useHistory } from "react-router-dom";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";

function Index() {
  const [medicalHistory, setMedicalHistory] = useState({
    chronicConditions: [],
    pastHistoryData: [],
    patientAllergyData: [],
    surgicalHistoryData: [],
    familyData: [],
    socialHistoryData: [],
    medicationData: [],
    immunisations: [],
    emc: [],
  });
  const [selectedHistory, setSelectedHistory] = useState("chronic");
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    PatientchronicConditions();
    PastHistory();
    PatientAllergies();
    SurgicalHistory();
    FamilyHistory();
    SocialHistory();
    Medication();
    Immunisations();
  }, []);

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = localStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const PatientchronicConditions = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
    };
    MedicalHistoryService.PatientchronicConditions(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          chronicConditions: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const PastHistory = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PastMedicalHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          pastHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const PatientAllergies = () => {
    let payload = {
      patientCode: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientAllergiesList(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          patientAllergyData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const SurgicalHistory = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientSurgicalHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          surgicalHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const FamilyHistory = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
    };
    MedicalHistoryService.PatientFamilyHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          familyData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const SocialHistory = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientSocialHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          socialHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const Medication = () => {
    let payload = {
      patientCode: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientMedication(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          medicationData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const Immunisations = () => {
    let payload = {
      patientId: selectedRpmPatient?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientImmunisation(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          immunisations: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const renderContent = () => {
    switch (selectedHistory) {
      case "chronic":
        return (
          <div>
            {selectedHistory === "chronic" &&
              medicalHistory.chronicConditions.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Chronic:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.chronicDescription}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "pastMed":
        return (
          <div>
            {selectedHistory === "pastMed" &&
              medicalHistory.pastHistoryData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Past Medical:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.pastInfo}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "allergy":
        return (
          <div>
            {selectedHistory === "allergy" &&
              medicalHistory.patientAllergyData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Drug Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.drugAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Food Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.foodAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Chemical Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.chemicalAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Other Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.otherAllergy}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "social":
        return (
          <div>
            {selectedHistory === "social" &&
              medicalHistory.socialHistoryData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Social History:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.description}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Occupation:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.occupation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Marital Status:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.maritalStatus}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with family:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.familyRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with friends:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.friendsRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with community:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.communityRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with people at work :
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.colleagueRelation}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "family":
        return (
          <div>
            {selectedHistory === "family" &&
              medicalHistory.familyData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Reason:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user?.description}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "surgical":
        return (
          <div>
            {selectedHistory === "surgical" &&
              medicalHistory.surgicalHistoryData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Surgery:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.surgicalInfo}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "medication":
        return (
          <div>
            {selectedHistory === "medication" &&
              medicalHistory.medicationData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Drug Name:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.drugName}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Dosage:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.dosage}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Frequency:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.frequency}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Duration:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.duration}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Indication:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.indication}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Side Effect:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.sideEffects}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Composition:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.compliance}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Adverse Effects :
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.adverseEffects}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Advice related to medicines :
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.adviceRelatedMedicine}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "immunization":
        return (
          <div>
            {selectedHistory === "immunization" &&
              medicalHistory.immunisations.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Immunisation:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user?.description}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      default:
        return null;
    }
  };

  const handleSelectHistory = (value) => {
    setSelectedHistory(value);
  };

  const handleNavigation = () => {
    history.push(APP_ROUTES.RPMMEDICALHISTORY);
  };

  return (
    <div>
      <div className="bg-white rounded-lg p-3 flex flex-col justify-between border">
        <div className="flex justify-between items-center pb-2">
          <div className="text-black text-base font-sans font-bold mr-2 min-w-fit-content">
            Medical History
          </div>
          <Select
            value={selectedHistory}
            style={{ width: "180px" }}
            className="text-xs small-select font-sans font-medium"
            onChange={handleSelectHistory}
            options={[
              { value: "chronic", label: "Chronic Conditions" },
              { value: "pastMed", label: "Past Medical History" },
              { value: "allergy", label: "Allergy" },
              { value: "surgical", label: "Surgical History" },
              { value: "family", label: "Family History" },
              { value: "social", label: "Social History" },
              { value: "medication", label: "Medications" },
              { value: "immunization", label: "Immunizations" },
            ]}
          />
        </div>
        <div className="text-sm text-gray-500 space-y-1 border rounded-lg mt-3 h-72 p-2 overflow-y-scroll scrollHide">
          <div className="max-h-[400px] overflow-y-auto scrollWidth pr-1">
            {renderContent()}
          </div>
        </div>

        <div
          onClick={handleNavigation}
          className="text-center mt-3 text-brand-primaryColor hover:underline cursor-pointer text-sm font-inter font-medium"
        >
          See All
        </div>
      </div>
    </div>
  );
}

export default Index;
